export const ManagePurchaseOrderStatusEnum = {
  OPEN: 'Open',
  CLOSED: 'Closed',
};
export const StatusOptionEnum = {
  OPEN: 'O',
  CLOSED: 'C',
};

export const OrdertypeEnum = {
  PO: '0',
  WO: '1',
  KO: '2',
  MAN: '3',
};

export const TypeDataEnum = {
  PO: 'PO',
  WO: 'WO',
  KO: 'KO',
  MAN: 'MAN',
};

export const ReceiptTypeEnum = {
  ALL: 0,
  WITH_ORDERS: 1,
  WITHOUT_ORDERS: 2,
};

export const BooleanStringEnum = {
  TRUE: 'true',
  FALSE: 'false',
};

export const PrintTypeEnum = {
  Order: 'Order',
  Receipt: 'Receipt',
};

export const CreateEditReceiptInventoryEnum = {
  NEW: '0',
  EDIT: '1',
};


// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ManagePurchaseOrderEnum.js